import { Box, CircularProgress } from '@mui/material';

import { useTranslation } from 'react-i18next';
import { locations } from 'services/routes/locations';
import {
  TagsGrid,
  TagsGridHeader,
  TagsGridItem,
  TagsGridItemLabel,
} from '../TagsGrid';
import useFeaturedGenres from './useFeaturedGenres';

const FeaturedGenres: React.FC = () => {
  const { t } = useTranslation();

  const { data, loading, error } = useFeaturedGenres();

  if (loading) {
    return (
      <Box marginY={10} display="flex" justifyContent="center">
        <CircularProgress color="primary" size={64} />
      </Box>
    );
  }

  if (error) {
    return <Box>error: {error}</Box>;
  }

  return (
    <>
      {/* @ts-ignore */}
      <TagsGridHeader data-testid="featured-genres-header">
        {t('aiRecommendations:featuredGenres:header')}
      </TagsGridHeader>
      <TagsGrid>
        {data.map(({ label, image, link, name }) => (
          <TagsGridItem
            key={name}
            redirectionPath={`${locations.general.songList.pathname}${link}`}
            image={image}
          >
            <TagsGridItemLabel data-testid="featured-genre-label">
              {label}
            </TagsGridItemLabel>
          </TagsGridItem>
        ))}
      </TagsGrid>
    </>
  );
};

export default FeaturedGenres;
